export const BUSINESS_SCALE_OPTIONS = ["UMI", "UKE", "UME", "UBE"];
